import Axios from "axios";
import { Charge } from "../contexts/Payment/payment.context";

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const generateKey = async (randomKey: string) => {
  const response = await axios.post(`/generate-key`, { reference: randomKey }, {
    headers: {
      'Referer': "app.sarepay.com"
    }
  });
  return response.data;
};

export const chargePayment = async (payload: any) => {
  const response = await axios.post(`/v2/payment/charge`, payload, {
    headers: {
      'X-pub-key': process.env.REACT_APP_PUBLIC_KEY,
    }
  });
  return response.data.data;
};

export const authorizeCharge = async (
  payload: object,
) => {
  const response = await axios.post(
    `/v2/payment/submit-pin`,
    payload,
  );
  return response.data.data;
};

export const authorizeOtpCharge = async (
  payload: object,
) => {
  const response = await axios.post(
    `/v2/payment/submit-otp`,
    payload,
  );
  return response.data.data;
};

export const  get3dsCharge = async (reference: string) => {
  const response = await axios.post(`/checkout/redirect-auth-callback`, { reference: reference });
  return response.data;
};

export const authorize3dsCharge = async (reference: number | string) => {
  const response = await axios.post(
    `/v2/payment/verify-3ds`, { reference: reference }
  );
  return response.data.data;
};


export const updateChargeStatus = async (
  id: number,
  status: "success" | "failed"
): Promise<Charge> => {
  const response = await axios.patch(`/charges/${id}/update-status/${status}`);
  return response.data.data;
};

export const getCharge = async (
  reference: string,
  type = ""
): Promise<Charge> => {
  const response = await axios.get(
    `/payments/${reference}/charge?type=${type}`
  );
  return response.data.data;
};


